import { c as _c } from "react/compiler-runtime";
import { clsx } from 'clsx';
import styles from './LoyaltyTierBadges.module.css';
type LoyaltyTierBadgesVariant = 'desktop' | 'mobile' | 'total' | 'benefits';
interface LoyaltyTierBadgesProps {
  readonly tierName?: string;
  readonly variant?: LoyaltyTierBadgesVariant;
  readonly className?: string;
}
export const LoyaltyTierBadges = t0 => {
  const $ = _c(6);
  const {
    tierName,
    variant: t1,
    className
  } = t0;
  const variant = t1 === undefined ? "desktop" : t1;
  if (!tierName) {
    return null;
  }
  const t2 = styles[variant];
  let t3;
  if ($[0] !== className || $[1] !== t2) {
    t3 = clsx(styles.badge, t2, className);
    $[0] = className;
    $[1] = t2;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] !== t3 || $[4] !== tierName) {
    t4 = <span className={t3} data-test-id="loyalty-tier-badges">{tierName}</span>;
    $[3] = t3;
    $[4] = tierName;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  return t4;
};